import { useMemo } from "react";

export const InfoLine = ({ info, hide, testid }) => {
  const items = useMemo(() => Object.entries(info).filter(([k]) => !hide.includes(k)).map(([k, v]) => [k, k.replace(/_/g, " "), typeof v === "number" ? Math.round(v * 10) / 10 : v]), [info, hide]);
  return (
    <div className="mb-2 flex flex-wrap gap-x-3 font-mono text-[10px] text-zinc-500" data-testid={testid}>
      {items.map(([k, l, v]) => <span key={k}>{l}: <span className="text-zinc-300">{v}</span></span>)}
    </div>
  );
};
